import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import AuthCardLayout from 'layouts/AuthCardLayout';
import RegistrationForm from 'components/authentication/RegistrationForm';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import AppContext from 'context/Context';
const Registration = () => {
  const { t } = useTranslation('auth');
  const {
    config: { corp }
  } = useContext(AppContext);
  return (
    <AuthCardLayout
      leftSideContent={
        <p className="pt-3 text-white">
          {t('Have an account?')}
          <br />
          <Button
            as={Link}
            variant="outline-light"
            className="mt-2 px-4"
            to={`/${corp}/authentication/card/login`}
          >
            {t('Log in')}
          </Button>
        </p>
      }
      footer={false}
    >
      <h3>{t('Register')}</h3>
      <RegistrationForm layout="card" hasLabel />
    </AuthCardLayout>
  );
};

export default Registration;
